/**
 * Card chrome shared across component boundaries.
 *
 * Here rather than beside the components that own each look, because the
 * consumers are components that stub each other in tests: a class constant
 * exported from `BillingSection` or `IntegrationCategoriesSection` forces
 * every `vi.mock` of those modules — six suites and counting — to re-export
 * it, which is a lot of ceremony for a string. A plain module nobody stubs
 * costs none of that.
 *
 * Only shells that genuinely have two owners belong here; a class used in one
 * file should stay in that file.
 */

/** A cell in the integrations catalog grid. Worn by `CategoryCard`, and by the
 * Mail & Calendar card in the `settings-mail-beside-messaging` test arm, which
 * has to be indistinguishable from its neighbours — the arm's whole premise is
 * that the mail grant reads as one of the abilities. */
export const CATEGORY_CARD_CLASS =
  'bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-md transition-shadow'

/** An account card in the Billing/Mail grid at the top of Settings. `flex
 * flex-col` is load-bearing, not decoration: it is what lets Billing's action
 * row claim the slack with `mt-auto` when the grid stretches the pair to a
 * shared bottom edge, and what lets the Mail card's `mb-auto` do the same. */
export const ACCOUNT_CARD_CLASS =
  'bg-white rounded-2xl border border-gray-200 p-5 flex flex-col'
